{
  "common": {
    "productNoun": {
      "form": "formulario",
      "survey": "encuesta",
      "quiz": "cuestionario"
    },
    "productNounCapitalized": {
      "form": "Formulario",
      "survey": "Encuesta",
      "quiz": "Cuestionario"
    },
    "urlField": {
      "settingsTitle": "Defina la configuración del campo URL",
      "description": "Elija qué tipos de URL se permiten para este campo.",
      "allowAllDomains": "Permitir todos los dominios",
      "allowAllDomainsDescription": "Se acepta cualquier URL válida",
      "allowOnlyDomains": "Permitir solo estos dominios",
      "allowOnlyDomainsDescription": "Todo lo demás se rechaza",
      "blockDomains": "Bloquee estos dominios",
      "blockDomainsDescription": "Todo lo demás se acepta",
      "domainsAllowed": "Dominios permitidos",
      "domainsBlocked": "Dominios bloqueados",
      "domainPlaceholder": "p. ej., example.com",
      "domainPlaceholderAdd": "Añadir otro",
      "domainHint": "Escriba un dominio y pulse Intro para añadirlo.",
      "invalidDomain": "Introduzca un dominio válido sin http://, https:// ni una ruta.",
      "domainRequired": "Añada al menos un dominio para esta opción.",
      "singleUrlInfo": "Solo se admite una URL por campo. Para capturar múltiples URLs, cree campos separados."
    },
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "segundos",
    "other": "-- Otro --",
    "customFieldExistsError": "Ya existe un campo personalizado con este nombre",
    "requiredField": "Este campo es obligatorio",
    "uniqueKeyNotUniqueError": "Esta clave no es única",
    "save": "Guardar",
    "saving": "Guardando",
    "typeAnOption": "Escriba una opción",
    "unsaved": "No guardado",
    "noSubmissionsFound": "No se han encontrado envíos",
    "sortBy": "Filtrar por",
    "clearAll": "Borrar todo",
    "submitSurvey": "Enviar encuesta",
    "select": "Seleccionar",
    "data": "datos",
    "enterAmount": "Introduzca el importe",
    "disqualifyAfterSubmitLower": "Descalificar después de enviar",
    "errorRetryAgain": "Error, vuelve a intentarlo",
    "savedSuccessfully": "¡Se ha guardado correctamente!",
    "couldntSaveChanges": "No se han podido guardar los cambios. Inténtelo de nuevo.",
    "emailNotificationSettingsUpdated": "La configuración de sus notificaciones por correo electrónico se ha actualizado.",
    "autoResponderSettingsUpdated": ".La configuración de su respuesta automática se ha actualizado correctamente.",
    "bubbleRadioStyleImageAlt": "Estilo de botón de opción burbuja",
    "standardRadioStyleImageAlt": "Estilo estándar de botón de opción",
    "recurringFrequency": {
      "once": "Una vez",
      "daily": "Por día",
      "weekly": "Semanal",
      "monthly": "Mensual",
      "yearly": "Anual"
    },
    "saveExitConfirmationSubText": "Mostrar un modal de confirmación cuando el usuario salga de la página.",
    "yes": "Sí",
    "no": "No",
    "updated": "Actualizado",
    "new": "Nuevo",
    "title": "Título",
    "openSettings": "Abrir configuración",
    "cloneField": "Clonar campo",
    "removeField": "Eliminar campo",
    "description": "Descripción",
    "cannotAddThisField": "Este campo no se puede añadir",
    "cannotAddThisFieldSubheading": "Este {product} ya utiliza {existing} campos. Elimine todos los campos de 1 objeto antes de añadir {attempted} campos.",
    "overallOnly": "Solo general",
    "nextSlideDefault": "Diapositiva siguiente (por defecto)",
    "nextQuestion": "Siguiente pregunta",
    "searchAddress": "Buscar dirección",
    "recurringDonation": "Donación Recurrente",
    "recurringDonationDay": "Donación recurrente de 1 día",
    "recurringDonationWeek": "Donación recurrente de 1 semana",
    "recurringDonationMonth": "Donación recurrente de 1 mes",
    "recurringDonationYear": "Donación recurrente de 1 año",
    "integrate": "Integrar",
    "preview": "Previsualizar",
    "back": "Atrás",
    "close": "Cerrar",
    "goHighLevel": "GoHighLevel",
    "openMediaLibrary": "Abrir la mediateca",
    "alert": "Alerta",
    "proceed": "Proceder",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "delete": "Borrar",
    "embed": "Insertar",
    "link": "Enlazar",
    "linkModal": {
      "title": "Insertar enlace",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.ejemplo.com",
      "invalidUrl": "La URL no es válida"
    },
    "iframeEmbed": "Incrustación de iframe",
    "styles": "Estilos",
    "options": "Opciones",
    "quickAdd": "Añadir rápidamente",
    "customFields": "Campos personalizados",
    "addObjectFields": "Añadir campos de objeto",
    "personalInfo": "Información personal",
    "contactInfo": "Información de contacto",
    "submit": "Enviar",
    "address": "Dirección",
    "customized": "Personalizado",
    "layout": "Diseño",
    "showLabel": "Mostrar etiqueta",
    "showImage": "Mostrar imagen",
    "imageLayout": "Imagen Alineación del contenido",
    "imageLayoutSettings": "Configuración de Alineación del contenido de Imagen",
    "imageLayoutMode": "Modo de Alineación del contenido de la Imagen",
    "surveyDefault": "Predeterminado de la encuesta",
    "independent": "Independiente",
    "image": "Imagen",
    "desktop": "Escritorio",
    "mobile": "Móvil",
    "desktopImage": "Imagen de Escritorio",
    "mobileImage": "Imagen de móvil",
    "uploaded": "Subido",
    "changeImage": "Cambiar imagen",
    "uploadImage": "Subir una imagen",
    "remove": "Eliminar",
    "background": "Fondo",
    "buttonBackground": "Fondo del Botón",
    "gradient": "Gradiente",
    "type": "Tipo",
    "linear": "Lineal",
    "radial": "Radial",
    "angular": "Angular",
    "angle": "Ángulo",
    "stops": "Paradas",
    "startColor": "Color de inicio",
    "endColor": "Color final",
    "addColor": "Añadir color",
    "fontColour": "Color de la Fuente",
    "textFontColour": "Color de la fuente del texto",
    "subTextFontColour": "Color de la fuente del subtexto",
    "selectThemes": "Seleccionar tema",
    "selectOne": "Seleccionar uno",
    "enableIcon": "Habilitar icono",
    "iconType": "Tipo de icono",
    "iconPlacement": "Colocación de Iconos",
    "filled": "Rellenado",
    "textOnly": "Solo cuerpo",
    "border": "Borde",
    "borderType": "Tipo de borde",
    "cornerRadius": "Radio de la esquina",
    "width": "Ancho",
    "padding": "Margen",
    "top": "Superior",
    "bottom": "Inferior",
    "left": "Izquierda",
    "right": "Derecha",
    "center": "Centrar",
    "default": "Por defecto",
    "formDefault": "Formulario por defecto",
    "shadow": "Sombra",
    "color": "Color",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Difuminar",
    "spread": "Propagar",
    "fieldStyle": "Estilo de campo",
    "fontColor": "Color de la fuente",
    "inputTextFillColor": "Color de relleno del comentario/opinión",
    "inputTextColor": "Color del texto del comentario",
    "primaryColor": "Color principal",
    "primaryColorTooltip": "Controla el Color para el estado de desplazamiento y el estado Dinámico.",
    "primaryColorTooltipLearnMore": "Más información",
    "inputTextColorTooltip": "Controla el Color del texto escrito en los Campos de comentario/opinión.",
    "mapPrimaryColorToButtonColor": "Asigna el color principal al color del botón",
    "label": "Etiqueta",
    "fontFamily": "Familia tipográfica",
    "size": "Tamaño",
    "weight": "Peso",
    "fontWeightTooltip": "Aplicable en caso de párrafos",
    "fontWeightOptions": {
      "thin": "100 - Fino",
      "extraLight": "200 - Extraligero",
      "light": "300 - Ligero",
      "normal": "400 - Normal",
      "medium": "500 - Medio",
      "semiBold": "600 - Seminegrita",
      "bold": "700 - Negrita"
    },
    "placeholder": "Marcador de posición",
    "customCSS": "CSS personalizado",
    "backgroundImage": "Imagen de fondo",
    "headerImage": "Imagen de cabecera",
    "miscellaneous": "Miscelánea",
    "agencyBranding": "Elementos de marca de la agencia",
    "imageUploadMessage": "Haz clic o arrastra un archivo de imagen a esta área para subirlo",
    "backgroundImageTooltipMessage": "La imagen de fondo está pensada para cubrir toda la página, proporcionando un telón de fondo visualmente atractivo para el formulario. Para ver la imagen de fondo, haz clic en la opción de previsualización.",
    "headerImageTooltipMessage": "La imagen del encabezado está diseñada para cubrir todo el ancho del formulario y permanece posicionada en la parte superior del formulario. Para ver la imagen del encabezado, haz clic en la opción de previsualización.",
    "onSubmit": "Al enviar",
    "facebookPixelID": "ID de píxel de Facebook",
    "facebookPixelFunnelLabel": "¿Usando esto dentro de un embudo?",
    "facebookPixelFunnelText": "Déjalo en blanco: la configuración propia de Pixel y de consentimiento de cookies del embudo tomará el control.",
    "facebookPixelEmbedLabel": "¿Incrustar en otro sitio web?",
    "facebookPixelEmbedText": "Elija cómo se gestiona el consentimiento de cookies en el paso de código de inserción.",
    "facebookPixelConsentCallout": "El consentimiento de cookies se establece por incrustación, en",
    "facebookPixelConsentCalloutLink": "Integrar → Código de inserción",
    "facebookPixelEvents": "Eventos de píxel de Facebook",
    "onpageView": "En vista de página",
    "stickyContact": "Contacto fijo",
    "stickyContactMessage": "Recuerda y completa automáticamente los datos del contacto cuando el usuario regresa en el mismo dispositivo y navegador.",
    "generateSubmissionDocument": "Generar documento de envío",
    "generateSubmissionDocumentMessage": "Cree automáticamente un PDF imprimible de cada envío y adjúntelo a los documentos del contacto",
    "saveQuizSubmissionAsPdf": "Guardar la entrega del cuestionario como PDF",
    "saveQuizResultAsPdf": "Guarde el resultado del cuestionario como PDF",
    "showSubmissionInConversationsFeed": "Crear conversación al enviar",
    "showSubmissionInConversationsFeedMessage": "Cree automáticamente un hilo de conversación cuando se envíe este formulario y realice el seguimiento por correo electrónico, SMS u otros canales desde la pestaña Conversaciones.",
    "fieldDescription": "Descripción del campo",
    "fieldTitle": "Título del campo",
    "queryKey": "Clave de consulta",
    "querykeyTooltipMessage": "La clave de consulta que puede usarse como parámetro de URL para rellenar este campo",
    "required": "Obligatorio",
    "hidden": "Oculto",
    "hiddenValue": "Valor oculto",
    "enableCountryPicker": "Habilitar el selector de países",
    "altText": "Texto alternativo",
    "optionImageAlt": "Imagen de opción",
    "bannerAlt": "pancarta",
    "avatarAlt": "Nombre del avatar",
    "alignment": "Alineación",
    "imageWidth": "Ancho de la imagen",
    "imageHeight": "Altura de la imagen",
    "logic": "Lógica",
    "pleaseInput": "Introduce",
    "editHTML": "Editar HTML",
    "textStyle": "Estilo de texto",
    "subText": "Subtexto",
    "text": "Texto",
    "buttonStyle": "Estilo de botón",
    "fullWidth": "Ancho completo",
    "htmlMessage": "El HTML personalizado va aquí",
    "htmlEditorHeader": "JAVASCRIPT / HTML PERSONALIZADO",
    "htmlEditorBodyMessage": "Añade tu código aquí",
    "scriptAdded": "¡Script añadido!",
    "sourceAddedForm": "Fuente «Nombre del formulario»",
    "sourceAddedSurvey": "Fuente «Nombre de la encuesta»",
    "sourceAddedQuiz": "Fuente «Nombre del cuestionario»",
    "yesSave": "Sí, Guardar",
    "cancelKeep": "Cancelar, mantener",
    "done": "Hecho",
    "addElement": "Añadir elemento",
    "addUrlLike": "Por favor, incluya URLs válidas como",
    "doNotAddRelativePath": "No añadas rutas relativas como",
    "or": "o",
    "addCustomFields": "Añadir campos personalizados",
    "customFieldSearch": "Buscar por nombre",
    "selectedCount": "Seleccionados: {count}",
    "noFieldsFound": "No se han encontrado campos",
    "noFieldsMatchQuery": "No hay campos que coincidan con «{query}». Pruebe con otro término o cree un nuevo campo.",
    "clearSearch": "Borrar la búsqueda",
    "addFieldWithCount": "Añadir campo {count} | Añadir {count} campos",
    "noFieldsYet": "Aún no hay campos",
    "noFieldsForObject": "Este objeto todavía no tiene campos. Cree uno para comenzar.",
    "createField": "Crear campo",
    "enterSourceValue": "Introduce el valor de origen",
    "shortLabel": "Etiqueta corta",
    "shortLabelPlaceholder": "Fuente a Etiqueta corta",
    "labelPlaceholder": "Tipo una etiqueta",
    "imagePlaceholder": "Imagen",
    "fillValuesPlaceholder": "Añada valores",
    "customCSSTooltip": "Los CSS personalizados tienen prioridad sobre el estilo del formulario y los temas y pueden tener un impacto en el estilo del tema.",
    "fontFamilyTooltip": "El creador admite todo tipo de fuentes, aunque no puedas verla en la lista. Búscala en el menú desplegable.",
    "angleTooltip": "Controla la dirección del gradiente. 0° es derecha, 90° es abajo, 180° es izquierda, 270° es arriba.",
    "useGDPRCompliantFont": "Usa una fuente compatible con el RGPD",
    "enableTimezone": "Habilitar zona horaria",
    "inputStyle": "Estilo de entrada",
    "conditionalLogicAlertOnSubmit": "La lógica condicional tendrá prioridad sobre el mensaje/redirigirá aquí",
    "conditionalLogicAlertOnShowHide": "La lógica condicional tendrá prioridad sobre la configuración oculta aquí",
    "placeholderFacebookPixelIdInput": "Introduce el ID de píxel de Facebook",
    "doNotShowMessage": "No mostrar de nuevo",
    "creatingForm": "Creada tu Formulario...",
    "creatingSurvey": "Creada tu Encuesta...",
    "creatingQuiz": "Creada tu cuestionario...",
    "errorCreatingForm": "Hay un error Creada tu formulario. Por favor, Vuelva a intentarlo.",
    "errorCreatingSurvey": "Hay un error Creada tu Encuesta. Por favor, Vuelva a intentarlo.",
    "errorCreatingQuiz": "Ha habido un error Creada tu cuestionario. Por favor, Vuelva a intentarlo.",
    "redirectMessage": "Será redirigido a:",
    "themes": {
      "themes": "Temas",
      "alertThemeMessage": "Cambiar de tema hará que se pierdan todas las modificaciones de estilo actuales.",
      "useTheme": "Usar tema",
      "removeTheme": "Eliminar tema"
    },
    "box": "Cuadro",
    "line": "Línea",
    "message": "Mensaje",
    "openUrl": "Redirigir a la URL",
    "borderTypeList": {
      "dotted": "Punteado",
      "dashed": "Discontinuo",
      "solid": "Liso",
      "none": "Ninguno"
    },
    "button": "Botón",
    "emailNotification": "Notificación por correo electrónico",
    "emailNotificationSubheader": "Recibir un correo electrónico cuando alguien rellene tu formulario",
    "subject": "Asunto",
    "emailTo": "Correo electrónico (Para)",
    "senderName": "Nombre del remitente",
    "senderNameWarning": "Tu (nombre de la subcuenta) se añadirá si se deja en blanco",
    "emailError": "Se requiere al menos una dirección de correo electrónico",
    "emailTooltip": "Introduzca una o más direcciones de correo electrónico que deben recibir esta alerta de envío de formularios. La primera dirección va en «Para»; las adicionales se consideran «Cc».",
    "emailTooltipForm": "Introduzca una o más direcciones de correo electrónico que deben recibir esta alerta de envío de formularios. La primera dirección va en «Para»; las adicionales se consideran «Cc».",
    "emailTooltipSurvey": "Introduzca una o más direcciones de correo electrónico que deban recibir esta alerta de envío de encuesta. La primera dirección va en «Para»; las adicionales se consideran «Cc».",
    "emailTooltipQuiz": "Introduzca una o más direcciones de correo electrónico que deben recibir esta alerta de envío de cuestionarios. La primera dirección va en «Para»; las adicionales se consideran «Cc».",
    "clear": "Borrar",
    "filter": "Filtrar",
    "noResults": "No hay resultados",
    "search": "Buscar",
    "showNotificationsSettings": "Mostrar configuración de notificaciones",
    "emailServicePaid": "Esta función es un servicio de pago y generará cargos en función del uso.",
    "integration": "Integración",
    "validation": {
      "fieldRequired": "El campo es obligatorio",
      "maxLengthExceeded": "Máx. Longitud excedida ({max} carácter)"
    },
    "securityValidation": {
      "title": "Problemas de seguridad detectados. No se permiten los siguientes elementos:",
      "cookieAccess": "Acceso a cookies detectado (document.cookie). Esto no está permitido por razones de seguridad.",
      "storageAccess": "localStorage.getItem() - no está permitido leer desde localStorage.",
      "evalUsage": "No se permite el uso de eval() ya que puede ejecutar código arbitrario.",
      "dynamicFunction": "No se permite la creación dinámica de funciones (new Function) por razones de seguridad.",
      "stringExecution": "No se permite pasar cadenas a setTimeout/setInterval, ya que puede ejecutar código arbitrario. Utilice referencias de funciones en su lugar.",
      "unclosedTag": "Se ha detectado una etiqueta HTML sin cerrar (por ejemplo, una <style> sin su correspondiente </style>). Cierre todas las etiquetas antes de guardar; de lo contrario, es posible que la página publicada no se cargue"
    },
    "products": {
      "subscriptionBadge": "Suscripción",
      "trialBadge": "{days} días de prueba gratuita",
      "setupFee": "Cuota única de configuración",
      "quantity": "Cantidad",
      "productImageAlt": "Imagen del producto",
      "bumpIconAlt": "Icono de opción adicional"
    },
    "payment": {
      "payments": "Pagos",
      "paymentProviders": "Proveedores de pagos",
      "paymentProvidersDescription": "Conecte un proveedor de pagos para empezar a aceptar pagos.",
      "connectedProviders": "Proveedores conectados",
      "requireCreditCard": "Exigir tarjeta para pedidos de $0",
      "requireCreditCardTooltip": "Cuando está habilitado, los clientes deben introducir una tarjeta de crédito incluso para compras de 0 $.",
      "connectProviders": "Conecte proveedores",
      "loading": "Cargando...",
      "generalTab": "General",
      "productTab": "Producto",
      "connected": "Conectado",
      "connect": "Conectar",
      "liveModeOn": "Modo en tiempo real",
      "status": "Estado",
      "test": "Prueba",
      "live": "En tiempo real",
      "paymentFields": "Campos de pago",
      "suggestAnAmount": "Sugerir una cantidad",
      "recurringPayments": "Pagos Recurrentes",
      "selectCurrency": "Seleccionar moneda",
      "tagActiveBGColor": "Color de la etiqueta activa",
      "includeOtherAmount": "Incluir otra cantidad",
      "footerInfo": "Información de pie de página",
      "paymentType": "Tipo de pago",
      "sellProducts": "Vender productos",
      "customAmount": "Cantidad personalizada",
      "collectPayment": "Cobrar el pago",
      "generalSettings": "Campos generales",
      "securePayments": "*Bloquear y pagos seguros al 100%*",
      "error": {
        "addMainProductFirst": "Añadir a PRINCIPAL Producto primero",
        "priceNotFoundForBumpProduct": "No se encontrado el Precio para el Producto ofrecido/complementario",
        "productAlreadyAdded": "El Producto ya se ha añadido"
      },
      "product": {
        "addProduct": "Añadir producto",
        "productSettings": "Configuración del producto",
        "bumpTag": "Opción adicional",
        "settingsAria": "Configuración del producto",
        "deleteAria": "Eliminar producto",
        "selectProduct": "Seleccionar producto",
        "editThisProduct": "Para editar este producto",
        "clickHere": "Haz clic aquí",
        "show": "Mostrar",
        "description": "Descripción",
        "image": "Imagen",
        "layoutSettings": "Configuración del diseño",
        "singleColumn": "Columna única",
        "twoColumn": "Dos columnas",
        "threeColumn": "Tres columnas",
        "maxProductError": "Se permiten un máximo de 20 productos en un formulario",
        "productSelectPlaceholder": "Selecciona un producto",
        "orderConfirmation": "Confirmación del pedido",
        "orderConfirmationWarning": "La página de confirmación del pedido se mostrará una vez que el pago se haya realizado correctamente",
        "quantity": "Cantidad",
        "createProduct": "Para crear un producto",
        "noProductsAdded": "Todavía no se han añadido productos",
        "productsWillShowHere": "Una vez que estés incluido en los productos, se mostrarán Derecha aquí",
        "chooseProductType": "Seleccionar Tipo de Producto",
        "mainProduct": "PRINCIPAL Producto",
        "primaryOffer": "Oferta principal",
        "checkoutAddOn": "Complemento de proceso de pago",
        "pricingOptions": "Opciones de precios",
        "pricingOptionsPlaceholder": "Seleccione las opciones de precios (por defecto: todas)",
        "all": "TODO",
        "addOrSelectProducts": "Añada o seleccione productos",
        "onceYouAddProductsTheyWillShowUpRightHere": "Una vez que añada productos, se mostrarán aquí",
        "addProducts": "Añadir productos"
      },
      "bumProduct": {
        "price": "Precio",
        "variant": "Variante",
        "headline": "Titular",
        "otoHeadline": "Titular de la OTO",
        "otoText": "OTO Cuerpo",
        "enableImage": "Habilitar Imagen",
        "imageMessage": "Cogeremos el Por defecto Producto Imagen",
        "orUploadADifferentImage": "O Subir a Imagen diferente",
        "bumpProducts": "Productos complementarios",
        "bumpProduct": "Producto ofrecido/complementario",
        "enableBump": "Habilitar complementario",
        "orderBumpStyle": "Estilo Venta adicional",
        "classic": "Clásico",
        "modern": "Moderno",
        "icon": "Icono",
        "bumpTemplate": "Seleccionar Plantilla",
        "highlightText": "Destacar Cuerpo",
        "showPrice": "Mostrar Precio",
        "bumpPriceColor": "Precio adicional",
        "bumpIconColor": "Icono de complemento",
        "bumpBackgroundColor": "Fondo de relieve",
        "highlightTextColor": "Destacar Cuerpo",
        "headlineColor": "Titular",
        "otoHeadlineColor": "Titular de la OTO",
        "otoTextColor": "OTO Cuerpo",
        "bumpBorderColor": "Borde",
        "priceRequired": "El precio es obligatorio",
        "headlineRequired": "El titular es obligatorio",
        "otoHeadlineRequired": "El encabezado de OTO es obligatorio",
        "otoTextRequired": "Se requiere OTO Text",
        "bumpProductTooltip": "Un Pequeño Complemento ofrecido durante el Proceso de pago a Multiplicar Ordenar Valor. Los clientes pueden incluirlo en un clic de Individual .",
        "templateOne": "Plantilla 1",
        "templateTwo": "Plantilla 2",
        "templateThree": "Plantilla 3",
        "animationIcon": {
          "none": "Ninguno",
          "arrow": "Flecha",
          "fire": "Fuego",
          "plus": "Más",
          "giftBox": "Caja de regalo",
          "timer": "Cuenta atrás",
          "cracker": "Cracker",
          "snack": "Tentempié",
          "partyBalloon": "Globo de fiesta",
          "flash": "Flash",
          "money": "Moneda",
          "spaceShuttle": "Transbordador Espacio"
        }
      },
      "coupons": {
        "coupons": "Cupones",
        "enableCoupon": "Habilitar cupón",
        "couponAlignment": "Alineación de cupones",
        "left": "Izquierda",
        "right": "Derecha",
        "fullWidth": "Ancho completo",
        "tooltipMessage": "Determina la posición de la introducción de un cupón entre los siguientes tipos"
      }
    },
    "addressSettings": {
      "autoComplete": "Completar automáticamente la dirección",
      "addressfields": "Campos de dirección",
      "placeholderSearch": "Buscar una dirección",
      "autoCompleteTooltip": "Ofrece la capacidad de buscar y completar automáticamente la dirección.",
      "streetAddress": "Dirección postal",
      "autoCompleteAddressTitle": "Automático Terminar dirección",
      "newBadge": "Nuevo",
      "defaultLabel": "Dirección",
      "searchPlaceholder": "Buscar Dirección",
      "mandataorySearch": {
        "title": "Obligatorio para seleccionar la dirección in Buscar Bar",
        "primaryText": "Autocompletar solo para la Dirección postal",
        "secondaryText": "Cuando Habilitado, Cuando un Usuario interactúa con la Dirección Campo, Entonces debe seleccionar una Dirección válida para continuar.",
        "secondaryText1": "Cuando Deshabilitado Entonces pueden Proceder sin seleccionar una Dirección in la barra Buscar."
      }
    },
    "autoResponder": "Respuesta automática",
    "workflow": "Flujo de trabajo",
    "workflowSubheader": "Automatice lo que sucede después de que se envíe un formulario",
    "workflowTitle": "Cree su propio flujo de trabajo sencillo.",
    "workflowDescription": "Utilice flujos de trabajo para gestionar sus seguimientos después de que los contactos interactúen con su formulario. Por ejemplo, enviarles un correo electrónico de seguimiento o un SMS",
    "createWorkflow": "Crear flujo de trabajo",
    "workflowVisualAlt": "Visual del flujo de trabajo",
    "autoResponderSubheader": "Enviar un correo electrónico automatizado a la persona que envía el formulario (el correo electrónico incluye una copia de la información que ha introducido en el formulario)",
    "replyToEmail": "Responder al correo electrónico",
    "open": "Abierto",
    "won": "Ganado",
    "lost": "Perdido",
    "abandon": "Abandonar",
    "selectAPipeline": "Selecciona una secuencia",
    "stage": "Paso",
    "status": "Estado",
    "opportunityValue": "Valor del cliente potencial",
    "createNewPipeline": "Crear una nueva secuencia",
    "editOpportunitySettings": "Editar la configuración de clientes potenciales",
    "contact": "Contacto",
    "opportunity": "Cliente potencial",
    "business": "Empresa",
    "add": "Añadir",
    "manage": "Gestionar",
    "more": "Más",
    "opportunityHeading": "¿Dónde quieres que se actualice tu oportunidad?",
    "date": {
      "dateSettings": "Configuración de fecha",
      "dateFormat": "Formato de fecha",
      "dateSeparator": "Separador de fechas",
      "dateFormatTooltipMessage": "Selecciona un formato de fecha. D representa el día, M el mes e Y el año",
      "dateSeparatorTooltipMessage": "Selecciona un separador para separar el día, el mes y el año en el formato seleccionado en el formato de fecha",
      "disablePicker": "Desactivar selector"
    },
    "dateTime": {
      "tabGeneral": "General",
      "tabFieldSettings": "Configuración de campos",
      "collectHeading": "Seleccione qué debe recopilar este campo",
      "collectDate": "Fecha",
      "collectTime": "Tiempo",
      "collectDateTime": "Fecha y hora",
      "collectTypeLockedTooltip": "El tipo de recopilación solo puede modificarse antes de que se guarde el campo",
      "placeholderTextPlaceholder": "Añadir texto de marcador de posición",
      "shortLabelPlaceholder": "Añada etiqueta corta",
      "fieldSettingsBanner": "Defina el rango de fechas o tiempos permitidos, restrinja los días que los usuarios pueden seleccionar y elija cómo se muestra el valor.",
      "allowedDateRange": "Rango de fechas permitido",
      "dateModeAny": "Cualquier fecha",
      "dateModeFuture": "Solo fechas futuras",
      "dateModePast": "Solo fechas anteriores",
      "dateModeRange": "Intervalo de fechas específico",
      "futureQuestion": "¿Qué fechas pueden elegir los usuarios?",
      "futureAny": "Cualquier fecha futura",
      "futureAnyDesc": "Los usuarios pueden elegir cualquier fecha posterior a la fecha actual. Por ejemplo, reservar una reunión en cualquier momento del año siguiente.",
      "futureBuffer": "Después del tiempo de margen",
      "futureBufferDesc": "Los usuarios solo pueden elegir fechas posteriores a un número determinado de días. Por ejemplo, permitir reservas a partir de tres días desde hoy.",
      "futureBufferSuffix": "días desde hoy",
      "futureRolling": "Dentro de un intervalo de fechas determinado",
      "futureRollingDesc": "Los usuarios pueden elegir fechas dentro de un intervalo futuro definido. Por ejemplo, permitir reservas dentro de los próximos 30 días.",
      "futureRollingPrefix": "Siguiente",
      "futureRollingSuffix": "días",
      "rangeLabel": "Intervalo de fechas específico",
      "rangeStart": "Fecha de inicio",
      "rangeEnd": "Fecha de finalización",
      "availableDays": "Días disponibles",
      "allowedTimeRange": "Intervalo de tiempo permitido",
      "timeModeAny": "En cualquier momento",
      "timeModeRange": "Intervalo de tiempo específico",
      "timeRangeLabel": "Intervalo de tiempo específico",
      "timeStart": "Hora de inicio",
      "timeEnd": "Hora de finalización",
      "timeFormatLabel": "Formato de tiempo",
      "timeFormat24": "24 horas",
      "timeFormat12": "A. M. / P. M.",
      "timePlaceholder": "HH:MM",
      "defaultTimeLabel": "Hora por defecto",
      "defaultTimeHelper": "Pre-rellene con una hora actual o personalizada.",
      "defaultTimeNone": "Ninguno",
      "defaultTimeCurrent": "Actual",
      "defaultTimeCustom": "Personalizado",
      "customTimeLabel": "Hora personalizada",
      "customTimeError": "Introduzca una hora válida en formato HH:MM",
      "disableCalendarPopup": "Desactivar ventana emergente del calendario",
      "meridianAm": "a. m.",
      "meridianPm": "p. m.",
      "daysError": "Seleccione al menos un día disponible",
      "dateRangeError": "La fecha de finalización debe ser posterior o igual a la fecha de inicio",
      "timeRangeError": "La hora de finalización debe ser posterior a la de inicio",
      "saveBlockedTitle": "El campo de fecha y hora está incompleto",
      "saveBlockedDescription": "Corrija los errores de validación de fecha y hora resaltados antes de guardar.",
      "weekday": {
        "mon": "Lun.",
        "tue": "Mar.",
        "wed": "Mié.",
        "thu": "Jue.",
        "fri": "Vie.",
        "sat": "Sáb.",
        "sun": "Dom."
      }
    },
    "restoreVersion": "Restaurar versión",
    "versionHistory": "Historial de versiones",
    "versionPreviewTitle": "Vista previa de la versión",
    "errorMessage": "Error, vuelve a intentarlo",
    "version": "Versión:",
    "currentVersion": "Versión actual",
    "messageStyling": "Estilo del mensaje",
    "validateEmailHeader": "Validar el correo electrónico",
    "validateEmailDescription": "El botón se hará visible una vez que el usuario introduzca su correo electrónico. Esta función está diseñada para ayudarte a generar clientes potenciales de calidad.",
    "verifyEmail": "Verificar el correo electrónico",
    "validatePhoneHeader": "Validar el teléfono",
    "validatePhoneDescription": "El botón se hará visible una vez que el usuario introduzca su teléfono. Esta función está diseñada para ayudarte a generar clientes potenciales de calidad.",
    "verifyPhone": "Verificar teléfono",
    "validatePhoneWarning": "Para habilitar la verificación OTP por SMS, asegúrate de que tu número de teléfono esté configurado en la configuración de tu ubicación",
    "addAnotherTnc": "Añada otro término y condición",
    "tnc1": "T y C 1",
    "tnc2": "T y C 2",
    "deleteCaps": "ELIMINAR",
    "deleteConfirmation": "Escriba ELIMINAR para confirmar",
    "marginPadding": "Margen y relleno",
    "style": {
      "formLayoutType": "Tipo de formulario",
      "layoutType": "Tipo de Diseño",
      "surveyType": "Tipo de encuesta",
      "oneColumn": "Una columna",
      "twoColumn": "Dos columnas",
      "singleLine": "Una sola línea",
      "fieldWidth": "Ancho de campo",
      "labelAlignment": {
        "labelAlignment": "Alineación de etiquetas",
        "labelWidth": "Ancho de la etiqueta"
      },
      "fieldSpacing": "Espaciado entre campos",
      "imageFieldSpacing": "Imagen y espaciado de campo",
      "imageCornerRadius": "Radio de la esquina de la imagen",
      "color": "color",
      "fontColor": "Color de la fuente",
      "inputBackgroundColor": "Color de fondo del comentario",
      "inputBorder": "Borde de comentario/opinión",
      "layout": "Diseño",
      "colorsAndBackground": "Colores y fondo",
      "imageLayout": {
        "imageLayout": "Alineación del contenido de la imagen",
        "showImage": "Mostrar imagen",
        "image": "Imagen",
        "desktop": {
          "topFixed": "Arriba fijo",
          "leftCenter": "Izquierda Centrar",
          "rightCenter": "Centrar a la derecha",
          "leftFixed": "Fijo a la Izquierda",
          "rightFixed": "Fijo a la derecha",
          "background": "Fondo"
        },
        "mobile": {
          "header": "Encabezado",
          "background": "Fondo"
        }
      },
      "focusPoint": {
        "title": "Punto Focal",
        "reset": "Restablecer",
        "noImage": "No se ha subido ninguna imagen"
      },
      "advanceSettings": "Configuración avanzados",
      "inputField": "Campo de entrada",
      "borderWidth": "Ancho del borde",
      "borderColor": "Color del borde",
      "borderStyle": "Estilo de borde",
      "fontSize": "Tamaño de la fuente",
      "fontWeight": "Grosor de la fuente",
      "labelColor": "Color de la etiqueta",
      "placeholderColor": "Color del marcador de posición",
      "shortLabelColor": "Color de etiqueta corta"
    },
    "replyToTooltip": "Especifique la dirección de correo electrónico a la que deben dirigirse las respuestas a esta notificación. Utilice {'{'}{'{'}contact.email{'}'}{'}'} para que los destinatarios puedan responder directamente a la persona que completó el formulario.",
    "content": "Contenido",
    "calculations": "Cálculos",
    "uploadOptions": "Opciones de subida",
    "opportunitySettingsWarning": "Ajusta la configuración de oportunidades haciendo clic en el botón Edit Opportunity Settings.",
    "startValue": "Valor de Inicio",
    "endValue": "Valor de Finalización",
    "today": "Hoy",
    "thisWeek": "Esta semana",
    "last7Days": "Últimos 7 días",
    "thisMonth": "Este mes",
    "last30Days": "Últimos 30 días",
    "question": "Pregunta",
    "createContactOnPartialSubmission": "Crear contacto en envío parcial",
    "howItWorks": "¿Cómo funciona?",
    "createContactOnPartialSubmissionDescription": "Termina la diapositiva y haz clic en «Next». Se creará y almacenará automáticamente un nuevo contacto.",
    "swapWarningMessageSurvey": "Las opciones de edición o intercambio afectarán a este campo personalizado en todos los lugares donde se use el campo. También puede restablecer la lógica condicional. ",
    "swapWarningMessageForm": "Editar o intercambiar opciones afectará a este campo personalizado en todos los lugares donde se use. ",
    "migrationWarningMessage": "Esta funcionalidad se ha migrado a la lógica condicional de la encuesta.",
    "optionLabel": "Etiqueta de opción",
    "calculationValue": "Valor de cálculo",
    "addOption": "Añadir opción",
    "addOtherOption": "Añadir la opción \"Otro\"",
    "otherOptionLabel": "Otro",
    "otherOptionPlaceholder": "Por favor, escriba otra opción aquí",
    "enableCalculations": "Activar cálculos",
    "allowOtherOption": "Permitir otra opción",
    "productSelectionSubtext": "Habilitar Individual O múltiple Selección de producto",
    "multi": "Multi",
    "single": "Individual",
    "productSelectionHeading": "Selección de Producto",
    "spreadToColumns": "Distribuir a columnas",
    "columns": "Columnas",
    "customstyle": "Estilo",
    "standard": "Estándar",
    "bubble": "Bubble",
    "radioStyles": {
      "standardAlt": "Estilo estándar de botón de opción",
      "bubbleAlt": "Estilo de botón de opción burbuja"
    },
    "data": "Datos",
    "integratePopup": {
      "title": "Integrar formulario",
      "embedCode": "Incrustar código",
      "useInFunnelOrEmbedCode": "Uso en el embudo/código de inserción",
      "iframeEmbed": "Insertar de iframe",
      "layout": {
        "title": "Incrustar tipo de diseño",
        "description": "Seleccione un diseño para incrustarlo en un embudo o en un sitio web externo",
        "allowMinimize": "Permitir minimizar",
        "minimizedTitlePlaceholder": "Título minimizado",
        "leftAlignAlt": "Alinear a la izquierda",
        "rightAlignAlt": "Alinear a la derecha"
      },
      "triggerType": "Tipo de activador",
      "triggers": {
        "seconds": "segundos"
      },
      "activation": {
        "title": "Opciones de activación",
        "visit": "visitar"
      },
      "deactivation": {
        "title": "Opciones de desactivación",
        "times": "veces"
      },
      "copyEmbedCode": "Copiar el código de incrustación",
      "copyFormLink": "Copiar el enlace del formulario",
      "openFormLink": "Abrir el enlace del formulario",
      "invalidInput": "¡Entrada no válida!",
      "funnel": {
        "funnel": "Embudo",
        "chooseStep": "Seleccionar un paso",
        "copyCodeAndOpenFunnel": "Copiar Código y Abrir Embudo"
      },
      "share": {
        "share": "Compartir",
        "shareViaSocials": "Compartir Vía Redes sociales",
        "copyLink": "Copiar enlace"
      },
      "email": {
        "email": "Correo electrónico",
        "shareViaEmail": "Compartir Vía Correo electrónico",
        "emailButton": "Correo electrónico",
        "blankTemplate": "Plantilla en blanco",
        "emailMarketingTemplates": "Plantillas de Marketing Correo electrónico",
        "or": "O",
        "chooseTemplate": "Elija entre sus plantillas",
        "continue": "Continuar"
      }
    },
    "rating": {
      "icon": "Icono",
      "iconAlignment": "Alineación de los Icono",
      "count": "Recuento",
      "lowestRating": "Mín. Valoración",
      "highestRating": "Máx. Valoración",
      "iconSelectedState": "Región/provincia/estado Seleccionado del Icono",
      "iconUnselectedState": "Región/provincia/estado del Icono no seleccionado",
      "rating": "Valoración",
      "ratingSettings": "Configuración de Valoración",
      "calculationType": {
        "calculationType": "Cómo archivar Valoración Campos in Personalizado Campos",
        "calculationTypeTooltip": "Cuando Tú Frecuencia algo 4 de 5 estrellas, significa: - Absoluto: 4 de 5 - Porcentaje: 80 - Fracción: 0,8",
        "absolute": "Absoluto",
        "percentage": "Porcentaje",
        "fraction": "Fracción"
      }
    },
    "desktopMode": "Modo de escritorio",
    "mobileMode": "Modo móvil",
    "versions": "Variantes",
    "advanced": "Avanzado",
    "edit": "Editar",
    "settings": "Configuración",
    "submissions": "Envíos",
    "analytics": "Análisis",
    "notifications": "Notificaciones",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "customValues": "Valores personalizados",
    "pickBgFromImage": "Añade un difuminado al fondo del cuadro de mensaje. Si elige un color de fondo para el cuadro de mensaje, este aparecerá sobre el cuadro de mensaje difuminado.",
    "pickBgFromImageTip": "Elija un Color con alto Comparar para la Imagen de fondo. Mensaje: No se aplicará si el Fondo del Formulario no tiene Imagen",
    "messageBackgroundBlur": "Difuminado de fondo",
    "confirmationMessage": "Mensaje de confirmación",
    "deleteOption": "Opción de Borrar",
    "deleteConfirmationModal": {
      "defaultDescription": "Eliminar una opción afectará a este Campo Personalizado en todas las plazas donde se use el Campo. ¿Estás seguro de que deseas borrarlo?",
      "validationMessage": "Introduce Borrar para guardar.",
      "validationError": "Introduce Borrar"
    },
    "disqualifyImmediately": "Descalificar inmediatamente",
    "disqualifyAfterSubmit": "Descalificar después de enviar",
    "generalSettings": "Configuración General",
    "advancedSettings": "Configuración avanzados",
    "customFieldName": "Personalizado Sector/industria Nombre",
    "customFieldNameTooltip": "Este Nombre de sector/industria es único por Personalizado Sector/industria.",
    "customFieldNameTooltipContact": "Estos campos permiten a los usuarios capturar detalles adicionales sobre una persona, como su tipo de lead, cumpleaños o método de contacto preferido.",
    "customFieldNameTooltipContactLearnMore": "Más información",
    "customFieldNameTooltipOpportunity": "Estos campos se utilizan para rastrear datos específicos de cada oportunidad, incluyendo información como el presupuesto o un objetivo de cierre.",
    "customFieldNameTooltipOpportunityLearnMore": "Más información",
    "customFieldNameTooltipCompany": "Estos campos permiten la captura de información a nivel organizacional (por ejemplo, para proveedores, clientes o agencias) que está vinculada a los contactos.",
    "customFieldNameTooltipCompanyLearnMore": "Más información",
    "customFieldNameTooltipCustomObject": "Estos campos permiten a los usuarios recopilar datos específicos del negocio, como detalles sobre activos, vehículos o propiedades, e integrar esta información en su sistema CRM.",
    "customFieldNameTooltipCustomObjectLearnMore": "Más información",
    "uniqueKey": "Clave única",
    "uniqueKeyTooltip": "Esta clave es el identificador del sistema para el campo personalizado. Una vez configurado, no se podrá cambiar.",
    "uniqueKeyTooltipLearnMore": "Más información",
    "selectContactAssociation": "Seleccione la asociación con los contactos",
    "selectObjectAssociation": "Seleccione la asociación entre {objectA} y {objectB}",
    "pickHowRecordsLink": "Ambos objetos están en este formulario, por lo que el envío debe saber cómo se relacionan.",
    "association": "Asociación",
    "newAssociationBetween": "Nueva asociación entre {objectA} y {objectB}",
    "opportunitySetupTitle": "Configure esta oportunidad",
    "opportunitySetupSubtitle": "Seleccione dónde aterriza",
    "opportunitySetupSubtitleLinked": "Seleccione dónde aterriza, y cómo se vincula a {object}",
    "opportunityPlacement": "Ubicación de la oportunidad",
    "newPipeline": "Nueva secuencia",
    "associations": "Asociaciones",
    "createNewAssociation": "Crear una nueva Relación",
    "selectAnAssociation": "Seleccionar una asociación",
    "loadingAssociations": "Cargando asociaciones...",
    "unknownAssociation": "Asociación Desconocida",
    "manyToMany": "Muchos a Muchos",
    "failedToLoadAssociations": "No se han podido cargar las asociaciones.",
    "noAssociationsFound": "No se han encontrado relaciones",
    "keepThisField": "Mantener este Sector/industria",
    "association": "Asociación",
    "customObject": "Objeto personalizado",
    "customObjects": "Objetos personalizados",
    "object": "Objeto",
    "editAssociation": "Editar Relación {objectName}",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Campos",
    "primaryFieldWarning": "{fieldName} es un campo PRINCIPAL para {objectSingular} y es Obligatorio para crear O Actualizar un {objectSingular}.",
    "primaryFieldTitle": "{fieldName} es Obligatorio para crear o Actualizar el Documento {objectSingular}.",
    "removeAllFields": "Borrar todos los Campos {objectSingular}",
    "customObjectsFallback": "Objetos personalizados",
    "noneAssociation": "Ninguno",
    "noneAssociationDescription": "No hay relación con los Contactos (no hay Campos de Contacto aquí)",
    "survey": {
      "layoutType": "Tipo de Encuesta",
      "oneQuestionPerPage": "Una pregunta a la vez",
      "allQuestionsOnePage": "Muchos a la Vez"
    },
    "quizQuestions": "Cuestionario Consultar",
    "choiceElements": "Componentes seleccionados",
    "otherElements": "Otro Componentes",
    "listEditor": {
      "prefillValueHeader": "Valor de Prerrellenar",
      "labelPlaceholder": "Etiqueta",
      "valuePlaceholder": "Valor",
      "optionRequiredError": "La opción Campo es Obligatorio"
    },
    "field": "Campo",
    "scoreEditor": {
      "addFieldPlaceholder": "Añadir Campo",
      "fieldLabel": "Campo",
      "numberLabel": "número"
    },
    "fileUploadEditor": {
      "fileTypes": "Tipos de Archivo",
      "all": "cada",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV",
      "fileAccess": "Acceso al archivo",
      "fileAccessDescription": "Elija quién puede acceder a los archivos subidos a este campo Esta configuración no se puede cambiar después de crear el campo",
      "fileAccessLocked": "Una vez creado el campo, no se podrá cambiar su configuración de acceso a archivos",
      "privateFiles": "Archivos privados",
      "privateFilesTooltip": "Solo los usuarios autorizados pueden ver y descargar archivos",
      "publicFiles": "Archivos públicos",
      "publicFilesTooltip": "Cualquiera con el enlace del archivo puede ver y descargar archivos."
    },
    "ok": "De acuerdo",
    "allowMultipleFiles": "Habilitar múltiples Archivos",
    "maxFileLimit": "Límite Máx. de Archivo",
    "privacyPolicy": "Política de privacidad",
    "termsOfService": "Condiciones del servicio",
    "colorPicker": {
      "brandColors": "Colores de marca",
      "defaultColors": "Colores por defecto",
      "globalCustomColors": "Colores globales personalizados"
    },
    "billingFrequency": "Frecuencia de Facturación",
    "otherAmount": "Otra cantidad",
    "exampleUrlPlaceholder": "https://www.ejemplo.com",
    "checkboxStyles": {
      "standardAlt": "Estilo estándar de casilla de verificación",
      "bubbleAlt": "Estilo de casilla de verificación tipo burbuja"
    },
    "previewIcons": {
      "exportAlt": "Icono de exportación",
      "shipmentAlt": "Icono de envío",
      "resultAlt": "Icono de la página de resultados"
    },
    "examples": {
      "sampleUrl": "https://ejemplo.com"
    },
    "showing": "Mostrando",
    "of": "de",
    "enterCouponCode": "Introduzca el código del cupón",
    "apply": "Aplicar",
    "paymentWillBeProcessed": "El pago se procesará en cuanto usted continúe con el siguiente paso",
    "paymentWillBeProcessedNextSlide": "El pago se procesará en cuanto el usuario avance a la siguiente diapositiva",
    "showThisAlertToUsers": "Mostrar esta alerta a los usuarios",
    "sixteenDigitCardNumber": "Número de tarjeta de 16 dígitos",
    "mmYy": "MM / AA",
    "cvc": "CVC",
    "threeDigitCode": "Código de 3 dígitos",
    "enterCardNumber": "Introduzca el número de tarjeta",
    "pleaseFillRequiredFields": "Rellene todos los campos obligatorios.",
    "opportunitySettingsIncomplete": "Configuración de la oportunidad incompleta",
    "opportunitySettingsIncompleteDescription": "Este formulario incluye campos de Oportunidad, pero la configuración de la oportunidad no se ha actualizado. Configure la oportunidad para poder guardar el formulario",
    "ariaAttributes": {
      "iconSearch": "Búsqueda de iconos"
    },
    "alt": {
      "standardRadioStyle": "Estilo del botón de opción estándar",
      "bubbleRadioStyle": "Estilo del botón de opción en burbuja"
    },
    "value": "Valor",
    "jumpTo": "Saltar a",
    "thankYouJohnDoe": "Gracias, Juan Pérez",
    "total": "Total",
    "urlExamples": {
      "simple": "ejemplo.com",
      "https": "https://ejemplo.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.ejemplo.com/path"
    },
    "quizThankYou": "Gracias por tomarse el tiempo para completar este cuestionario."
  },
  "overallScore": {
    "defaultTitle": "Puntuación general"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Elección Individual",
      "multipleChoice": "Elección múltiple",
      "yesNo": "Sí / No",
      "shortAnswer": "Corto Respondido",
      "longAnswer": "Respondido largo",
      "number": "número",
      "singleDropdown": "Menú desplegable Individual",
      "multiDropdown": "Menú desplegable múltiple"
    },
    "personal": {
      "fullName": "Nombre Completo",
      "firstName": "Nombre",
      "lastName": "Apellidos",
      "dateOfBirth": "Fecha de nacimiento",
      "phone": "Teléfono",
      "email": "Gmail",
      "fullNamePlaceholder": "Introduzca su nombre completo",
      "firstNamePlaceholder": "Introduzca su nombre",
      "lastNamePlaceholder": "Introduzca su(s) apellido(s)",
      "dateOfBirthPlaceholder": "DD / MM / AAAA",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Botón"
    },
    "integration": {
      "sellProducts": "Vender productos",
      "collectPayment": "Cobrar el Pago"
    },
    "address": {
      "address": "Dirección",
      "streetAddress": "Dirección postal",
      "city": "Ciudad",
      "state": "Región/provincia/estado",
      "country": "País",
      "postalCode": "Código postal",
      "organization": "Grupo",
      "website": "Sitio web",
      "websitePlaceholder": "https://yourwebsite.com",
      "addressPlaceholder": "Dirección postal",
      "streetAddressPlaceholder": "Introduce tu dirección completa",
      "cityPlaceholder": "Introduzca su ciudad",
      "statePlaceholder": "Introduzca el estado",
      "countryPlaceholder": "Introduzca su país",
      "postalCodePlaceholder": "Código postal o código ZIP",
      "organizationPlaceholder": "Introduzca su organización"
    },
    "text": {
      "singleLine": "Línea Individual",
      "multiLine": "Multi Línea",
      "textBoxList": "Lista de cuadros de texto",
      "singleLinePlaceholder": "Introduzca su texto",
      "multiLinePlaceholder": "Escriba el mensaje aquí"
    },
    "choiceElements": {
      "singleDropdown": "Menú desplegable Individual",
      "multiDropdown": "Menú desplegable múltiple",
      "checkbox": "Casilla de verificación",
      "radio": "Botón de opción",
      "singleDropdownPlaceholder": "Seleccione una opción",
      "multiDropdownPlaceholder": "Elija una o más opciones",
      "pictureChoice": {
        "label": "Selección de imagen",
        "multipleSelection": "Selección múltiple",
        "selectionTypeLocked": "El tipo de selección no se puede cambiar después de que se guarde este campo personalizado.",
        "imageRequiredBeforeSave": "Cada opción en un elemento de elección de imagen debe tener una imagen.",
        "labelRequiredBeforeSave": "Cada opción en un elemento de elección de imagen debe tener una etiqueta.",
        "duplicateOptionLabelsBeforeSave": "Cada opción en un elemento de Elección de Imagen debe tener una etiqueta única.",
        "selectionLimitInvalidBeforeSave": "Introduzca un límite de selección válido para el elemento Picture Choice.",
        "selectionLimit": "Límite de selección",
        "unlimited": "Ilimitado",
        "exact": "Exacto",
        "range": "Intervalo",
        "exactSelections": "Selecciones exactas",
        "minimum": "Mínimo",
        "maximum": "Máximo",
        "options": "Opciones",
        "optionSettings": "Configuración de opciones",
        "showOptionLabel": "Mostrar etiqueta de opción",
        "addOption": "Añadir opción",
        "otherOption": "Otra opción",
        "imageFit": "Ajuste de la imagen",
        "cover": "Cubrir",
        "contain": "Contener",
        "fill": "Rellenar",
        "spreadToColumns": "Distribuir en columnas",
        "columns": "Columnas",
        "numberOfColumns": "Número de columnas",
        "desktopColumnsLimit": "Máximo {count} columnas en escritorio",
        "mobileColumnsLimit": "Máximo {count} columnas en móvil",
        "otherOptionLabel": "Etiqueta de otra opción",
        "optionLabel": "Etiqueta de opción",
        "image": "Imagen",
        "media": "Contenido multimedia",
        "otherImageUploadUnavailable": "No se puede subir una imagen para la opción Otro",
        "removeImage": "Eliminar imagen",
        "deleteOption": "Eliminar la opción",
        "altText": "Texto alternativo"
      }
    },
    "customized": {
      "text": "Enviar mensaje de texto",
      "html": "Html",
      "htmlPlaceholder": "El HTML Personalizado va aquí",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Desafío",
      "botProtection": "Protección contra bots",
      "verificationMode": "Modo de Verificación",
      "interactive": "Interactivo",
      "invisible": "Invisible",
      "invisibleModeDescription": "Esta verificación se ejecuta automáticamente en segundo plano y no será visible para los usuarios",
      "fieldHiddenWarning": "Este campo está oculto y no se verá en el formulario.",
      "verifyHuman": "Verifique que usted es humano",
      "privacy": "Privacidad",
      "help": "Ayuda",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Fuente",
      "termsAndConditions": "Términos y condiciones",
      "termsAndConditionsPlaceholder": "Acepto los términos y condiciones Emitido Vía la empresa. Vía proporcionando mi Número de teléfono, acepto a Heredar Enviar mensaje de texto mensajes De la empresa.",
      "score": "Puntuación",
      "scorePlaceholder": "Ejemplo: Su puntuación es del 100%"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Introduzca una URL",
      "image": "Imagen",
      "fileUpload": "Subir de Archivo",
      "monetary": "Monetario",
      "number": "número",
      "datePicker": "Fecha y hora",
      "datePickerLegacy": "Selector de fecha",
      "datePickerGeneratedName": "Fecha",
      "timePickerGeneratedName": "Tiempo",
      "dateTimePickerGeneratedName": "Fecha y hora",
      "signature": "Firma",
      "monetaryPlaceholder": "Introduzca el importe",
      "signaturePlaceholder": "Firme aquí",
      "numberPlaceholder": "Introduzca un número",
      "datePickerPlaceholder": "DD / MM / AAAA",
      "imageUploadPlaceholder": "Todavía no se ha añadido ninguna imagen",
      "imageUploadSubText": "Suba al almacenamiento multimedia o arrastre y suelte",
      "imageUploadButtonText": "Subir una imagen",
      "fileText": "Archivo",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Haga clic para subir"
    },
    "customstyle": "Estilo",
    "standard": "Estándar",
    "bubble": "Bubble"
  },
  "survey": {
    "addSlideText": "Añadir elementos",
    "defaultScreenTitle": "Componentes de arrastrar y soltar",
    "defaultScreenDescription": "Mueva su pregunta a la página de {pageIndex} usando los elementos de la izquierda.",
    "typeOfBuilder": "Encuesta",
    "survyeStyle": "Estilo de encuesta",
    "surveyName": "Nombre de encuesta",
    "surveyElement": "Elemento de encuesta",
    "addSurveyElement": "Añadir elemento de encuesta",
    "cloneSlide": "Clonar diapositiva",
    "unsavedAlertMessage": "Hay trabajo sin guardar en la encuesta. ¿Seguro que quieres abandonar y descartar todo el trabajo que no has guardado?",
    "thirdPartyScriptAlertMessage": "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Por lo tanto, te recomendamos que revises el contenido de este script antes de guardarlo en la encuesta.",
    "integrateHeader": "Integrar encuesta",
    "integrateSubHeader": "Usa las siguientes opciones para integrar tu encuesta personalizada en tu sitio web",
    "integrateCopyLinkMessage": "Copia el enlace a continuación y compártelo fácilmente donde quieras.",
    "onSurveySubmission": "En el envío de encuestas",
    "saveExitConfirmation": "Guardar progreso para encuestas",
    "surveySettings": "Configuración de la encuesta",
    "oneQuestionAtTime": "Una pregunta cada vez",
    "backButton": "Botón de retroceso",
    "backButtonTooltipMessage": "El botón «Atrás» ayudará a los usuarios a pasar a la diapositiva anterior",
    "disableAutoNavigation": "Desactivar la navegación automática",
    "disableAutoNavigationTooltipMessage": "Navega automáticamente al Siguiente Deslizar Después a Usuario responde.",
    "autoNavigation": "Navegación Automático",
    "autoNavigationTooltipMessage": "Navega automáticamente al Siguiente Deslizar Después a Usuario responde.",
    "progressBar": "Barra de progreso",
    "progressBarTooltipMessage": "Al desactivar esta opción, se eliminará la barra de progreso de la encuesta",
    "disableAnimation": "Desactivar la animación",
    "disableAnimationTooltipMessage": "Al activar esta opción, se desactivará la animación de transición de la diapositiva",
    "scrollToTop": "Desplazarse hasta arriba",
    "scrollToTopTooltipMessage": "Si esta opción está activada, la encuesta se desplazará hasta la parte superior de la siguiente diapositiva",
    "submitSurvey": "Enviar encuesta",
    "disqualifyImmediately": "Descalificar inmediatamente",
    "disqualifyAfterSubmit": "Descalificar después de enviar",
    "disqualifyAfterSubmitLowerCase": "Descalificar después de enviar",
    "footerHTML": "Pie de página HTML",
    "footerHTMLMessage": "Puedes escribir CSS personalizado (usando una etiqueta de estilo) y HTML dentro del mismo cuadro",
    "editFooter": "Editar pie de página",
    "disqualifySettings": "Descalificar los ajustes",
    "disqualifyImmediatelyLabel": "Inmediatamente",
    "disqualifyAfterSubmitLabel": "Tras el envío",
    "slideConflictAlertMessage": "Esta diapositiva contiene varias preguntas que tienen una lógica establecida. Esto puede provocar algún comportamiento no deseado.",
    "addSlide": "Añadir diapositiva",
    "settings": "Configuración",
    "delete": "Eliminar",
    "slideDeleteAlertMessage": "¿Seguro que quieres eliminar esta diapositiva?",
    "slideDeleteBetweenAlertMessage": "Esta acción reorganizará las demás diapositivas. ¿Seguro que quieres eliminar esta diapositiva?",
    "slideLabel": "Diapositiva {n}",
    "slideName": "Nombre de la diapositiva",
    "slidePosition": "Posición de diapositiva",
    "jumpTo": "Saltar a",
    "jumpToSubText": "Vaya a una diapositiva específica",
    "enableTimezoneSurvey": "Al activar esta opción, se capturará la información de la zona horaria de la persona que envía la encuesta.",
    "footer": {
      "footer": "Pie de página",
      "enableNewFooter": "Habilitar nuevo pie de página",
      "stickToSurvey": " Cíñete a la encuesta",
      "backgroundFill": "Relleno de fondo",
      "footerHeight": "Altura del pie de página",
      "enableProgressBar": "Habilitar la barra de progreso",
      "buttons": "Botones",
      "button": "Botón",
      "buttonType": "Tipo de botón",
      "buttonTypeTooltip": "Elija cómo deben aparecer los botones de navegación en el pie de página de su encuesta",
      "fillNext": "Rellenar (siguiente)",
      "fillPrevious": "Rellenar (anterior)",
      "fillSubmit": "Rellenar (Enviar)",
      "textColor": "Texto del botón",
      "position": "Posición",
      "positionTooltip": "Elija cómo deben aparecer los botones de navegación en el pie de página de su encuesta",
      "previousText": "Anterior (texto)",
      "nextText": "Siguiente (texto)",
      "submitText": "Enviar (texto)",
      "fillComplete": "Rellenar completado",
      "fillInactive": "Rellenar inactivo",
      "footerType": "Tipo de pie de página",
      "stickToCard": "Fijar a la tarjeta",
      "stickToPage": "Fijar a la página",
      "stepTextColor": "Paso Cuerpo Color",
      "progressBarFill": "Barra de progreso Rellenar",
      "progressBarInactive": "Barra de progreso Inactivo",
      "arrowFill": "Rellenar de Flecha",
      "submitColorMobile": "Enviar (Color)",
      "arrowFillColor": "Color de Rellenar de la Flecha",
      "buttonTypes": {
        "textAndArrow": "Texto & Flecha",
        "onlyText": "Solo texto",
        "onlyArrow": "Solo flecha"
      },
      "positions": {
        "leftAndRight": "Izquierda y derecha"
      },
      "placeholders": {
        "prev": "Anterior",
        "next": "Siguiente",
        "submit": "Enviar"
      }
    },
    "surveyNotfication": "Notificación de encuesta",
    "style": {
      "surveyPadding": "Margen de la encuesta"
    },
    "integratePopup": {
      "shareOrEmbed": "Incrustar o compartir encuesta",
      "share": {
        "openFormLink": "Abrir Enlace de la Encuesta"
      },
      "email": {
        "emailSubheader": "Crea un correo electrónico en blanco e inserta tu encuesta, O selecciona una plantilla e insértala inmediatamente."
      }
    },
    "autoResponderSubheader": "Enviar un correo electrónico automatizado a la persona que envía el formulario (el correo electrónico incluye una copia de la información que ha introducido en el formulario)",
    "sendSubmissionsAsPdf": "Enviar el envío de encuesta en formato PDF",
    "switchToOneQuestionAtTimeOn": "Habilitar «Una pregunta por fecha» interrumpe tu Lógica del condicional real",
    "switchToOneQuestionAtTimeOff": "Deshabilitar «Una pregunta a la fecha» afecta a tu Lógica Config. condicional.",
    "switchToOneQuestionAtTimeOnWarning": "Algunas condiciones ya no funcionarán como se esperaba Cuando las preguntas son asistidos una a una Fecha.",
    "switchToOneQuestionAtTimeOffWarning": " Algunas condiciones diseñadas para Flujo de preguntas individuales dejarán de funcionar correctamente.",
    "createContactOnPartialSubmissionSubText": "Crea un contacto cuando un usuario hace clic en «Siguiente» en cualquier diapositiva, aunque no termine la encuesta.",
    "dragDrop": {
      "imageLabel": "Imagen {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Encuesta {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Política de privacidad</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Términos de servicio</a></p>",
      "smsConsent": "Consiento recibir notificaciones por SMS, alertas y comunicaciones de marketing ocasionales de la empresa. La frecuencia de los mensajes varía. Pueden aplicarse tarifas de mensajes y datos. Envíe AYUDA al (XXX) XXX-XXXX para obtener asistencia. Puede responder DETENER para cancelar la suscripción en cualquier momento."
    }
  },
  "form": {
    "typeOfBuilder": "Formulario",
    "formStyle": "Estilo del formulario",
    "formElement": "Elemento de formulario",
    "addFormElement": "Añadir elemento de formulario",
    "addConditionalLogic": "Añadir lógica condicional",
    "openConditionalLogic": "Abrir la lógica condicional",
    "inlineForm": "Formulario en línea",
    "formName": "Nombre del formulario",
    "fullScreenMode": "Modo de pantalla completa",
    "fullScreenModetooltip": "Si esta opción está activada, el formulario se expandirá por todo el ancho de su contenedor y se extenderá hasta el borde del área de incrustación sin sobrepasar el ancho del formulario.",
    "enableTimezoneForm": "Al activar esta opción, se capturará la información de la zona horaria de la persona que envía el formulario",
    "formSettings": "Configuración del formulario",
    "scheduleVisibility": {
      "title": "Visibilidad de {product} de programación",
      "subtitle": "Establezca cuándo debe comenzar y terminar este {product} a aceptar respuestas. Fuera de ese intervalo, los visitantes verán los mensajes que configure a continuación.",
      "formOpens": "{Product} se abre",
      "formCloses": "{Product} se cierra",
      "rightAway": "De inmediato",
      "never": "Nunca",
      "pickADate": "Elegir una fecha",
      "opensPlaceholder": "Se abre en cuanto usted publica",
      "closesPlaceholder": "Permanece abierto hasta que lo cierre",
      "date": "Fecha",
      "time": "Tiempo",
      "timezone": "Zona horaria",
      "timezoneHelp": "Se aplica tanto a los horarios de apertura como a los de cierre.",
      "timezonePlaceholder": "Seleccione una zona horaria",
      "timeline": {
        "notOpenYet": "Aún no se ha abierto",
        "acceptingResponses": "Aceptando respuestas",
        "closed": "Cerrado",
        "current": "Actual",
        "opens": "Abre",
        "closes": "Cierra"
      },
      "whatVisitorsSee": "Lo que ven los visitantes",
      "whatVisitorsSeeHelp": "Estas páginas solo se muestran fuera de la ventana abierta. Seleccione un estado para configurarlo.",
      "states": {
        "beforeTitle": "Antes de que se abra el {product}",
        "afterTitle": "Después de que el {product} cierre",
        "showsPage": "Muestra una página personalizada",
        "redirectsTo": "Redirige a {url}"
      },
      "showPage": "Mostrar una página",
      "showPageHelp": "Diseñe lo que verán los visitantes.",
      "openLink": "Abrir un enlace",
      "openLinkHelp": "Envíelos a otra URL.",
      "redirectUrl": "URL de redireccionamiento",
      "redirectUrlPlaceholder": "https://ejemplo.com",
      "redirectUrlHelp": "Los visitantes en este estado son enviados aquí en lugar de ver una página. Utilice una URL completa como https://ejemplo.com/ruta.",
      "redirectUrlInvalid": "Introduzca una URL válida que comience con http:// o https://, como https://example.com/path.",
      "defaultBeforeMessage": "Este {product} aún no está abierto",
      "defaultAfterMessage": "Este {product} ya está cerrado",
      "defaultBeforeBody": "Este {product} aún no acepta respuestas. Vuelva a comprobarlo una vez que se abra para enviar su respuesta",
      "defaultAfterBody": "¡Gracias por su interés! Este {product} ha dejado de aceptar respuestas. Póngase en contacto con el propietario de {product} si todavía necesita comunicarse con él",
      "closeAfterOpenError": "La hora de cierre debe ser posterior a la hora de apertura.",
      "preview": {
        "label": "Previsualizar",
        "labelHint": "— cómo lo ven los visitantes",
        "redirectTo": "Será redirigido a:",
        "poweredBy": "Impulsado por su agencia"
      },
      "appearance": {
        "title": "Apariencia",
        "cardBackground": "Fondo de tarjeta",
        "pageBackground": "Fondo de la página",
        "cornerRadius": "Radio de esquina",
        "cardWidth": "Anchura de la tarjeta",
        "cardHeight": "Altura de la tarjeta",
        "shadow": "Sombra",
        "autoPlaceholder": "Automático",
        "marginPadding": "Margen y relleno",
        "auto": "automático",
        "miscellaneous": "Miscelánea",
        "agencyBranding": "Elementos de marca de la agencia",
        "agencyBrandingHelp": "Muestre el logotipo y el nombre de su agencia en las páginas en estado cerrado.",
        "shadowOptions": {
          "none": "Ninguno",
          "soft": "Suave",
          "elevated": "Elevado"
        },
        "colors": {
          "default": "Por defecto",
          "lightGray": "Gris claro",
          "brandTint": "Color de marca",
          "blush": "Colorete",
          "dark": "Oscuro",
          "white": "Blanco",
          "coolGray": "Gris frío"
        }
      }
    },
    "saveExitConfirmation": "Guardar progreso de los formularios",
    "unsavedAlertMessage": "Hay trabajo sin guardar en el formulario. ¿Seguro que quieres abandonar y descartar todo el trabajo que no has guardado?",
    "thirdPartyScriptAlertMessage": "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Por lo tanto, te recomendamos que revises el contenido de este script antes de guardarlo en la encuesta.",
    "onFormSubmission": "En el envío del formulario",
    "integrateForm": "Integrar formulario",
    "embedlayoutType": "Tipo de Diseño Insertar",
    "embedlayoutTypeSubMessage": "Selecciona un diseño para incrustarlo en un embudo o en un sitio web externo",
    "triggerType": "Tipo de activador",
    "showOnScrolling": "Mostrar al desplazarse",
    "showAfter": "Mostrar después",
    "seconds": "segundos",
    "alwaysShow": "Mostrar siempre",
    "activationOptions": "Opciones de activación",
    "activateOn": "Activar el",
    "visit": "visitar",
    "alwaysActivated": "Siempre activado",
    "deactivationOptions": "Opciones de desactivación",
    "deactivateAfterShowing": "Desactivar después de mostrar",
    "times": "veces",
    "deactiveOnceLeadCollected": "Desactivar una vez que se haya recopilado el cliente potencial",
    "neverDeactivate": "No desactivar nunca",
    "copyEmbedCode": "Copiar código de incrustación",
    "copyFormLink": "Copiar enlace del formulario",
    "openFormLink": "Abrir enlace del formulario",
    "inline": "En línea",
    "inlineDescription": "Aparece un formulario en línea junto con el contenido de la página como elemento nativo. No se superpone y no se puede cerrar ni minimizar.",
    "inlineHoverDescription": "Aparece un formulario en línea junto con el contenido de la página como elemento nativo. No se superpone y no se puede cerrar ni minimizar.",
    "popup": "Ventana emergente",
    "popupDescription": "Una ventana emergente muestra el formulario como una superposición dentro de una caja de luz. No se puede minimizar, pero sí cerrar.",
    "popupHoverDescription": "Una ventana emergente muestra el formulario como una superposición dentro de una caja de luz. No se puede minimizar, pero sí cerrar.",
    "politeSlideIn": "Ventana deslizante respetuosa",
    "politeSlideInDescription": "Aparece una ventana deslizante en la parte inferior de la pantalla, que desaparece una vez cerrada.",
    "politeSlideInHoverDescription": "Aparece en la parte inferior de la pantalla y desaparece una vez cerrada",
    "stickySidebar": "Barra lateral fija",
    "stickySidebarDescription": "Aparecerá una barra lateral fija en el lateral de la pantalla que puede minimizarse para convertirse en una pestaña fijada al lateral de la ventana",
    "stickySidebarHoverDescription": "Aparecen en el lateral de la pantalla y pueden minimizarse para convertirse en una pestaña fijada al lateral de la ventana",
    "allowMinimize": "Permitir minimizar",
    "checkForCookieConsent": "Respetar el consentimiento de cookies del sitio anfitrión",
    "checkForCookieConsentTooltip": "Los eventos del píxel solo se activan después de que el visitante acepta las cookies de marketing en el sitio donde está incrustado este formulario. La detección automática busca GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi e IAB TCF.",
    "cookieConsentProvider": "Proveedor de consentimiento de cookies",
    "cookieConsentProviderPlaceholder": "Seleccione su banner de consentimiento de cookies",
    "cookieConsentProviderAutoDetect": "Detectar automáticamente",
    "modalHeight": "Altura del modal",
    "modalHeightPlaceholder": "Introducir la altura del modal",
    "conditonalLogic": {
      "conditions": "Condiciones",
      "noExistingCondition": "Todavía no existen condiciones",
      "freeRoamMessage": "Puedes ir por libre sin reglas… al menos, por ahora.",
      "addNewCondition": "Añadir nueva condición",
      "redirectToUrl": "Redirigir a la URL",
      "displayCustomMessage": "Mostrar un mensaje personalizado",
      "disqualifyLead": "Descalificar al cliente potencial",
      "showHideFields": "Mostrar/Ocultar campos",
      "jumpTo": "Saltar a",
      "redirectToUrlSubText": "Redirigir al usuario después del envío",
      "displayCustomMessageSubText": "Mostrar mensajes basados en las entradas de Activado Usuario",
      "disqualifyLeadSubText": "Filtrar las entradas bajo condiciones específicas",
      "showHideFieldsSubText": "Modificar el campo de visibilidad dinámicamente",
      "openBelowUrl": "Abre la URL a continuación",
      "showCustomMessage": "Mostrar mensaje personalizado",
      "alertConditionDelete": "¿Seguro que quieres eliminar esta condición?",
      "deleteCondition": "Eliminar condición",
      "conditionExecutedMessage": "Las condiciones se ejecutarán en orden descendente.",
      "allOperationOptions": {
        "isEqualTo": "Es igual a",
        "isNotEqualTo": "No es igual a",
        "contains": "Contiene",
        "doesNotContain": "No contiene",
        "startsWith": "Empieza por",
        "endsWith": "Termina con",
        "isEmpty": "Está vacío",
        "isFilled": "Está rellenado",
        "before": "Antes",
        "after": "Después",
        "greaterThan": "Mayor que",
        "lessThan": "Menor que",
        "between": "Entre",
        "isChecked": "Está marcado",
        "isNotChecked": "No está seleccionado"
      },
      "logic": {
        "if": "Si",
        "then": "Entonces",
        "and": "Y",
        "or": "O"
      },
      "phoneAlertMessage": "Para buscar números de teléfono con un código de país, debes incluir explícitamente el símbolo «+» en la consulta de búsqueda.",
      "deleteAlertMessage": "¿Seguro que quieres eliminar este campo? También se eliminará la condición asociada a este campo.",
      "deleteField": "Eliminar campo",
      "jumpToDescription": "Saltar a una diapositiva específica cuando se cumplen las condiciones",
      "cycleError": "No se puede guardar. Bucle detectado entre {a} y {b}",
      "jumpToSlide": "Saltar a la diapositiva",
      "submitSurvey": "Guardar Encuesta",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Hacer clic en Deslizar de la que desea saltar",
      "selectedSlide": "Diapositiva seleccionada",
      "typeValueHere": "Por favor, escriba un Valor aquí",
      "field": "Campo",
      "slide": "Deslizar",
      "selectFieldOrSlide": "Seleccionar Sector/industria o Deslizar",
      "selectFieldState": "Seleccionar Estado del Campo",
      "selectField": "Seleccionar campo",
      "selectOption": "Seleccionar Opción",
      "jumpToTarget": "Saltar a",
      "jumpToQuestion": "Ir a la Pregunta",
      "chooseQuestion": "Seleccionar Pregunta",
      "includeStart": "Incluir inicio",
      "includeEnd": "Incluir al final",
      "includeValue": "Incluir {value}",
      "hideField": "Ocultar Campo",
      "hideFields": "Ocultar campos",
      "showField": "Mostrar campo",
      "showFields": "Mostrar Campos",
      "additionalRulesPrefix": "... y",
      "additionalRulesSuffix": "otras reglas de {ifLabel}...",
      "shownTargetsWithMore": "{shown}, +{count} más",
      "noConditionsAlt": "Todavía no hay condiciones",
      "outcomeLabels": {
        "show": "Mostrar",
        "jumpTo": "Saltar a"
      }
    },
    "minimizedTitlePlaceholder": "Título minimizado",
    "dragYourElementFromLeft": "Arrastra tus elementos aquí desde la izquierda",
    "formNotification": "Notificación del formulario",
    "sendSubmissionsAsPdf": "Enviar el formulario como PDF",
    "style": {
      "formPadding": "Margen del formulario"
    },
    "integratePopup": {
      "shareOrEmbed": "Incrustar o compartir formulario",
      "share": {
        "openFormLink": "Abrir Enlace del Formulario"
      },
      "email": {
        "emailSubheader": "Crea un correo electrónico en blanco e inserta tu formulario, O selecciona una plantilla e insértala inmediatamente."
      }
    },
    "choosePosition": "Seleccionar Estado",
    "testBuild": "Compilación de prueba"
  },
  "quiz": {
    "quizElement": "Elemento del cuestionario",
    "quizNotification": "Notificación del cuestionario",
    "viewAndCustomise": "Ver y personalizar",
    "categoryAndScore": "Categoría y puntuación",
    "provideFeedback": "Proporcionar comentarios",
    "addQuizElement": "Añadir elemento del cuestionario",
    "typeOfBuilder": "Cuestionario",
    "addQuestions": "Añadir preguntas",
    "dragAndDropQuestion": "Arrastrar y suelta aquí un elemento de Pregunta .",
    "addNewPage": "Añadir Página",
    "editTemplate": "Editar Plantilla",
    "editResultPage": "Editar la página de resultados",
    "clonePage": "Clonar página",
    "category": {
      "category": "Categoría",
      "useCategoryWhen": "Utilizar categorías Cuando",
      "manageCategories": "Gestionar las Categorías",
      "howItWorks2": "Cómo funciona esto",
      "addCategoryMessage": "Añadir a nueva categoría",
      "assignCategoryMessage": "Asignar una categoría a cada opción",
      "editResultsMessage": "Mostrar la categoría puntuación in el Resultado página",
      "toEvaluateTheResponder": "Para comparar el respondedor en función de Activado, varios factores",
      "showMultipleCategoryScore": "Mostrar múltiples categorías de puntuación in el Resultado página",
      "displayVaryingContent": "Visualización variando el Contenido Activado de los resultados Página según Activado la Categoría nivel de puntuación",
      "addManage": "Añadir / Gestionar",
      "carouselAlt": "Diapositiva de vista previa de categoría"
    },
    "quizSettings": "Configuración del cuestionario",
    "saveExitConfirmation": "Guarda el progreso de los cuestionarios",
    "onQuizSubmission": "En el envío del cuestionario",
    "settings": "Configuración",
    "deletePage": "Eliminar página",
    "quizResult": {
      "resultTemplate": "Plantilla de Página de Resultados",
      "quizResultAlertMessage": "La página de resultados elegida se mostrará una vez finalizado el cuestionario",
      "overallScoreLabel": "Puntuación general",
      "resultTemplateAlt": "Vista previa de la plantilla de resultados del cuestionario"
    },
    "deleteSlideMessage": "¿Seguro que quieres eliminar esta diapositiva?",
    "autoResponderSubheader": "Enviar un correo electrónico automatizado a la persona que envía el cuestionario (el correo electrónico incluye una copia de la información que ha introducido en el cuestionario)",
    "sendSubmissionsAsPdf": "Enviar el cuestionario como PDF",
    "sendQuizResultsAsPdf": "Enviar el resultado del cuestionario como PDF",
    "integrateHeader": "Integrar cuestionario",
    "integrateSubHeader": "Usa las siguientes opciones para integrar tu cuestionario personalizado en tu sitio web",
    "integrateCopyLinkMessage": "Copia el enlace a continuación y compártelo fácilmente donde quieras.",
    "pageLabel": "Página {n}",
    "pageName": "Nombre de la página",
    "pagePosition": "Posición de la página",
    "createContactOnPartialSubmissionSubText": "Crea un contacto cuando un usuario hace clic en «Siguiente» en cualquier diapositiva, aunque no termine el cuestionario.",
    "integratePopup": {
      "shareOrEmbed": "Incrustar o compartir cuestionario",
      "share": {
        "openFormLink": "Abrir Enlace del cuestionario"
      },
      "email": {
        "emailSubheader": "Crea un Correo electrónico en blanco e Insertar tu cuestionario, O Seleccionar una Plantilla e Insertarla inmediatamente."
      }
    }
  },
  "textEditor": {
    "textAlign": "Alineación de texto",
    "list": "Lista",
    "sourceCode": "Código fuente",
    "resetStyle": "Restablecer estilo",
    "resetDocumentStyle": "Restablecer el estilo del documento"
  }
}
